import { render } from "./companies.vue?vue&type=template&id=068a7c68&scoped=true&ts=true&lang=pug"
import script from "./companies.vue?vue&type=script&lang=ts"
export * from "./companies.vue?vue&type=script&lang=ts"

import "./companies.vue?vue&type=style&index=0&id=068a7c68&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068a7c68"]])

export default __exports__